module.exports = __webpack_public_path__ + "static/media/welldone.2bbd36b6.mp3";